import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { SessionStoreRepository } from '../shared/repositories/session.repository';
import { PatientSchemasComponent } from "./patient/patient-schemas.component";
import { DoctorSchemasComponent } from "./doctor/doctor-schemas.component";
import { Observable } from 'rxjs';

@Component({
    selector: 'web-patient-schemas',
    templateUrl: './schemas.component.html',
    styleUrl: './schemas.component.scss',
    imports: [CommonModule, PatientSchemasComponent, DoctorSchemasComponent]
})

export class SchemasComponent {
    sessionService = inject(SessionStoreRepository);
    
    isPatient$: Observable<boolean> = this.sessionService.isPatient$;
}
